import React, { useState, useEffect, useRef } from 'react';

// ── API ────────────────────────────────────────────────────────
const API_URL =
  "https://homewalkers.realatixcrm.com/api/v1/users/create-with-params" +
  "?addedby=68da45a5b37ddfab3b73bd8b" +
  "&stage=68d110bbad5a0732ad44e5cf" +
  "&Channal=6a48bfa6a4cf5854ad69d511" +
  "&project=6a424455cbc3b90bfa64cd4b" +
  "&salesdata=68da75b5b37ddfab3b7463f5" +
  "&Communicationway=69159308820816f4ad71c3bf" +
  "&campaignid=68e3a33dbd4758877fb945a1" +
  "&includePhone2=false" +
  "&includeWhatsapp=false" +
  "&includeJobDesc=false" +
  "&includeQuestion1=true" +
  "&question1_text=%D8%A7%D9%84%D8%BA%D8%B1%D8%B6++%D9%85%D9%86+%D8%A7%D9%84%D8%B4%D8%B1%D8%A7%D8%A1+%D8%9F" +
  "&includeQuestion2=true" +
  "&question2_text=%D8%B9%D8%AF%D8%AF+%D8%A7%D9%84%D8%BA%D8%B1%D9%81+%D8%9F" +
  "&includeQuestion3=false" +
  "&includeQuestion4=false" +
  "&includeQuestion5=false";

// ── خيارات الفورم ──────────────────────────────────────────────
const purposeOptions = ['السكن', 'الاستثمار', 'سكن واستثمار'];
const roomOptions    = ['استوديو', '1 غرفة', '2 غرفة', '3 غرفة'];

// ── أكواد الدول ──────────────────────────────────────────────
const countryCodes = [
  { iso: 'ae', name: 'الإمارات',        dial: '+971' },
  { iso: 'sa', name: 'السعودية',        dial: '+966' },
  { iso: 'eg', name: 'مصر',             dial: '+20'  },
  { iso: 'kw', name: 'الكويت',          dial: '+965' },
  { iso: 'qa', name: 'قطر',             dial: '+974' },
  { iso: 'bh', name: 'البحرين',         dial: '+973' },
  { iso: 'om', name: 'عُمان',           dial: '+968' },
  { iso: 'jo', name: 'الأردن',          dial: '+962' },
  { iso: 'lb', name: 'لبنان',           dial: '+961' },
  { iso: 'iq', name: 'العراق',          dial: '+964' },
  { iso: 'sy', name: 'سوريا',           dial: '+963' },
  { iso: 'ye', name: 'اليمن',           dial: '+967' },
  { iso: 'ps', name: 'فلسطين',          dial: '+970' },
  { iso: 'ma', name: 'المغرب',          dial: '+212' },
  { iso: 'dz', name: 'الجزائر',         dial: '+213' },
  { iso: 'tn', name: 'تونس',            dial: '+216' },
  { iso: 'ly', name: 'ليبيا',           dial: '+218' },
  { iso: 'sd', name: 'السودان',         dial: '+249' },
  { iso: 'so', name: 'الصومال',         dial: '+252' },
  { iso: 'dj', name: 'جيبوتي',          dial: '+253' },
  { iso: 'km', name: 'جزر القمر',       dial: '+269' },
  { iso: 'mr', name: 'موريتانيا',       dial: '+222' },
  { iso: 'tr', name: 'تركيا',           dial: '+90'  },
  { iso: 'ir', name: 'إيران',           dial: '+98'  },
  { iso: 'pk', name: 'باكستان',         dial: '+92'  },
  { iso: 'in', name: 'الهند',           dial: '+91'  },
  { iso: 'bd', name: 'بنغلاديش',        dial: '+880' },
  { iso: 'lk', name: 'سريلانكا',        dial: '+94'  },
  { iso: 'np', name: 'نيبال',           dial: '+977' },
  { iso: 'ph', name: 'الفلبين',         dial: '+63'  },
  { iso: 'id', name: 'إندونيسيا',       dial: '+62'  },
  { iso: 'my', name: 'ماليزيا',         dial: '+60'  },
  { iso: 'cn', name: 'الصين',           dial: '+86'  },
  { iso: 'us', name: 'الولايات المتحدة', dial: '+1'   },
  { iso: 'gb', name: 'المملكة المتحدة', dial: '+44'  },
  { iso: 'fr', name: 'فرنسا',           dial: '+33'  },
  { iso: 'de', name: 'ألمانيا',         dial: '+49'  },
  { iso: 'it', name: 'إيطاليا',         dial: '+39'  },
  { iso: 'es', name: 'إسبانيا',         dial: '+34'  },
  { iso: 'ru', name: 'روسيا',           dial: '+7'   },
  { iso: 'ca', name: 'كندا',            dial: '+1'   },
  { iso: 'au', name: 'أستراليا',        dial: '+61'  },
  { iso: 'za', name: 'جنوب أفريقيا',    dial: '+27'  },
  { iso: 'ng', name: 'نيجيريا',         dial: '+234' },
  { iso: 'ke', name: 'كينيا',           dial: '+254' },
  { iso: 'et', name: 'إثيوبيا',         dial: '+251' },
  { iso: 'br', name: 'البرازيل',        dial: '+55'  },
  { iso: 'jp', name: 'اليابان',         dial: '+81'  },
  { iso: 'kr', name: 'كوريا الجنوبية',  dial: '+82'  },
];

const inputStyle = {
  width:        '100%',
  padding:      '13px 16px',
  border:       '1.5px solid #e0d8cc',
  borderRadius: '10px',
  fontSize:     '14px',
  fontFamily:   "'Cairo', sans-serif",
  color:        '#1a1a1a',
  background:   '#fff',
  outline:      'none',
  boxSizing:    'border-box',
  direction:    'rtl',
  transition:   'border-color 0.2s ease, box-shadow 0.2s ease',
};

const labelStyle = {
  fontSize:     '13px',
  fontWeight:   '600',
  color:        '#444',
  display:      'block',
  marginBottom: '7px',
  direction:    'rtl',
};

/**
 * EmmarRgisterModal
 * Props:
 *  - isOpen: boolean → يتحكم في ظهور المودال
 *  - onClose: function → تستدعى عند الإغلاق
 */
export const EmmarRgisterModal = ({ isOpen, onClose }) => {
  const formRef = useRef(null);

  const [formData, setFormData] = useState({
    name:              '',
    phone:             '',
    email:             '',
    question1_answer:  'السكن',
    question2_answer:  '',
  });
  const [countryIso, setCountryIso] = useState('ae');
  const [loading, setLoading] = useState(false);
  const [alert,   setAlert]   = useState({ show: false, message: '', ok: false });
  const [countryOpen, setCountryOpen] = useState(false);
  const countryWrapperRef = useRef(null);

  const selectedCountry = countryCodes.find((c) => c.iso === countryIso) || countryCodes[0];

  // إغلاق قائمة الدول عند الضغط بره
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (countryWrapperRef.current && !countryWrapperRef.current.contains(e.target)) {
        setCountryOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // منع سكرول الصفحة خلف المودال
  useEffect(() => {
    if (isOpen) {
      const prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prevOverflow; };
    }
  }, [isOpen]);

  // إغلاق بزرار Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!alert.show) return;
    const t = setTimeout(() => setAlert((p) => ({ ...p, show: false })), 5000);
    return () => clearTimeout(t);
  }, [alert.show]);

  const handleChange = (field) => (e) =>
    setFormData((p) => ({ ...p, [field]: e.target.value }));

  const handleFocus = (e) => {
    e.target.style.borderColor = '#c8a04a';
    e.target.style.boxShadow   = '0 0 0 3px rgba(200,160,74,0.12)';
  };
  const handleBlur = (e) => {
    e.target.style.borderColor = '#e0d8cc';
    e.target.style.boxShadow   = 'none';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const phone = formData.phone.trim();
    if (!phone || phone.replace(/\D/g, '').length < 6)
      return setAlert({ show: true, message: 'يرجى إدخال رقم هاتف صحيح', ok: false });

    const fullPhone = `${selectedCountry.dial}${phone.replace(/\D/g, '')}`;

    setLoading(true);
    setAlert({ show: false, message: '', ok: false });

    try {
      const res = await fetch(API_URL, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:             formData.name.trim() || 'no name',
          email:            formData.email.trim().toLowerCase() || '',
          phone:            fullPhone,
          question1_answer: formData.question1_answer,
          question2_answer: formData.question2_answer,
        }),
      });

      if (!res.ok) throw new Error(`${res.status}`);

      setAlert({ show: true, message: 'تم الإرسال بنجاح ✅', ok: true });
      setFormData({ name: '', phone: '', email: '', question1_answer: 'السكن', question2_answer: '' });
    } catch (err) {
      const status = err.message;
      setAlert({
        show: true,
        ok:   false,
        message:
          status.includes('409') ? 'رقم الهاتف مسجّل مسبقاً'
        : status.includes('400') ? 'بيانات غير صحيحة، يرجى المراجعة'
        : 'حدث خطأ، يرجى المحاولة مجدداً',
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
      style={{
        position:       'fixed',
        inset:          0,
        background:     'rgba(15,12,8,0.65)',
        zIndex:         1000,
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        padding:        '16px',
        backdropFilter: 'blur(5px)',
        overflowY:      'auto',
      }}
    >
      <div
        ref={formRef}
        style={{
          background:   '#fff',
          borderRadius: '18px',
          width:        '100%',
          maxWidth:     '460px',
          direction:    'rtl',
          fontFamily:   "'Cairo', sans-serif",
          position:     'relative',
          animation:    'emmarFadeInUp 0.35s ease',
          maxHeight:    '92vh',
          overflowY:    'auto',
          boxSizing:    'border-box',
          boxShadow:    '0 25px 70px rgba(0,0,0,0.35)',
        }}
      >
        {/* Header مع خلفية ذهبية */}
        <div
          style={{
            background: 'linear-gradient(135deg, #1a1a1a, #2b2620)',
            borderTopLeftRadius:  '18px',
            borderTopRightRadius: '18px',
            padding: 'clamp(22px, 5vw, 30px) clamp(20px, 5vw, 32px)',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div style={{
            position: 'absolute',
            top: '-40%',
            right: '-15%',
            width: '220px',
            height: '220px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(200,160,74,0.35), transparent 70%)',
          }} />

          <button
            onClick={onClose}
            aria-label="إغلاق"
            style={{
              position:   'absolute',
              top:        '14px',
              left:       '14px',
              width:      '32px',
              height:     '32px',
              display:    'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255,255,255,0.1)',
              border:     'none',
              borderRadius: '50%',
              fontSize:   '16px',
              cursor:     'pointer',
              color:      '#fff',
              lineHeight: 1,
              transition: 'background 0.2s ease',
              zIndex: 1,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.2)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.1)')}
          >
            ✕
          </button>

          <p style={{
            fontSize:      '11px',
            fontWeight:    '700',
            color:         '#c8a04a',
            letterSpacing: '3px',
            textTransform: 'uppercase',
            margin:        '0 0 10px 0',
            position: 'relative',
          }}>
            EMAAR GOLF FIELD
          </p>
          <h2 style={{
            fontSize:   'clamp(19px, 4.5vw, 24px)',
            fontWeight: '900',
            color:      '#fff',
            margin:     '0 0 8px 0',
            lineHeight: '1.3',
            position: 'relative',
          }}>
            لمزيد من التفاصيل
          </h2>
          <p style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.65)', margin: 0, position: 'relative' }}>
            سجل بياناتك وسنتواصل معك في أقرب وقت
          </p>
        </div>

        {/* Body */}
        <div style={{ padding: 'clamp(20px, 5vw, 30px) clamp(20px, 5vw, 32px)' }}>

          {alert.show && (
            <div style={{
              background:   alert.ok ? 'rgba(74,124,63,0.08)' : 'rgba(200,50,50,0.07)',
              border:       `1px solid ${alert.ok ? 'rgba(74,124,63,0.3)' : 'rgba(200,50,50,0.25)'}`,
              borderRadius: '10px',
              padding:      '11px 16px',
              marginBottom: '18px',
              fontSize:     '14px',
              fontWeight:   '600',
              color:        alert.ok ? '#2e5e26' : '#9b2020',
              display:      'flex',
              justifyContent: 'space-between',
              alignItems:   'center',
              gap: '10px',
            }}>
              <span>{alert.message}</span>
              <button
                onClick={() => setAlert((p) => ({ ...p, show: false }))}
                style={{ background: 'none', border: 'none', cursor: 'pointer',
                  color: 'inherit', fontSize: '16px', lineHeight: 1, flexShrink: 0 }}
              >✕</button>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

            {/* الاسم */}
            <div>
              <label style={labelStyle}>الاسم</label>
              <input
                type="text"
                placeholder="الاسم"
                value={formData.name}
                onChange={handleChange('name')}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={inputStyle}
              />
            </div>

            {/* رقم الهاتف */}
            <div>
              <label style={labelStyle}>
                رقم الهاتف <span style={{ color: '#c8a04a' }}>*</span>
              </label>
              <div
                ref={countryWrapperRef}
                style={{ display: 'flex', gap: '8px', direction: 'ltr', position: 'relative' }}
              >
                {/* زرار كود الدولة */}
                <button
                  type="button"
                  onClick={() => setCountryOpen((v) => !v)}
                  style={{
                    display:      'flex',
                    alignItems:   'center',
                    gap:          '6px',
                    flexShrink:   0,
                    width:        '108px',
                    padding:      '0 10px',
                    border:       '1.5px solid #e0d8cc',
                    borderRadius: '10px',
                    background:   '#fff',
                    cursor:       'pointer',
                    fontFamily:   "'Cairo', sans-serif",
                    fontSize:     '13px',
                    fontWeight:   '600',
                    color:        '#1a1a1a',
                  }}
                >
                  <img
                    src={`https://flagcdn.com/w20/${selectedCountry.iso}.png`}
                    alt={selectedCountry.iso}
                    style={{ width: '18px', borderRadius: '2px' }}
                  />
                  <span>{selectedCountry.dial}</span>
                  <span style={{ fontSize: '9px', opacity: 0.6, marginRight: 'auto' }}>▾</span>
                </button>

                {/* رقم الهاتف */}
                <input
                  type="tel"
                  inputMode="numeric"
                  placeholder="رقم الهاتف"
                  value={formData.phone}
                  onChange={handleChange('phone')}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  style={{ ...inputStyle, direction: 'ltr', textAlign: 'right', flex: 1 }}
                />

                {/* قائمة الدول */}
                {countryOpen && (
                  <div
                    style={{
                      position:   'absolute',
                      top:        'calc(100% + 8px)',
                      left:       0,
                      width:      '240px',
                      maxHeight:  '260px',
                      overflowY:  'auto',
                      background: '#fff',
                      borderRadius: '14px',
                      boxShadow:  '0 12px 35px rgba(0,0,0,0.25)',
                      zIndex:     30,
                      direction:  'rtl',
                    }}
                  >
                    {countryCodes.map((c) => (
                      <div
                        key={c.iso}
                        onClick={() => { setCountryIso(c.iso); setCountryOpen(false); }}
                        style={{
                          display:    'flex',
                          alignItems: 'center',
                          gap:        '8px',
                          padding:    '9px 12px',
                          cursor:     'pointer',
                          fontSize:   '13px',
                          fontFamily: "'Cairo', sans-serif",
                          background: c.iso === selectedCountry.iso ? '#fff6e0' : 'transparent',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = '#f5f5f5')}
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background =
                            c.iso === selectedCountry.iso ? '#fff6e0' : 'transparent')
                        }
                      >
                        <img src={`https://flagcdn.com/w20/${c.iso}.png`} alt={c.iso} style={{ width: '18px' }} />
                        <span style={{ flex: 1 }}>{c.name}</span>
                        <span style={{ color: '#888' }}>{c.dial}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* الإيميل */}
            <div>
              <label style={labelStyle}>الإيميل</label>
              <input
                type="email"
                placeholder="الإيميل"
                value={formData.email}
                onChange={handleChange('email')}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{ ...inputStyle, direction: 'ltr', textAlign: 'right' }}
              />
            </div>

            {/* الغرض من الشراء */}
            <div>
              <label style={labelStyle}>الغرض من الشراء</label>
              <select
                value={formData.question1_answer}
                onChange={handleChange('question1_answer')}
                onFocus={handleFocus}
                onBlur={handleBlur}
                style={{
                  ...inputStyle,
                  appearance:      'none',
                  WebkitAppearance:'none',
                  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23c8a04a' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E")`,
                  backgroundRepeat:   'no-repeat',
                  backgroundPosition: 'left 14px center',
                  paddingLeft:        '36px',
                  cursor:             'pointer',
                }}
              >
                {purposeOptions.map((o) => (
                  <option key={o} value={o}>{o}</option>
                ))}
              </select>
            </div>

            {/* عدد الغرف */}
            <div>
              <label style={labelStyle}>عدد الغرف</label>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {roomOptions.map((room) => (
                  <label
                    key={room}
                    style={{
                      display:      'flex',
                      alignItems:   'center',
                      gap:          '6px',
                      cursor:       'pointer',
                      fontSize:     '13px',
                      fontWeight:   '600',
                      color:        formData.question2_answer === room ? '#c8a04a' : '#555',
                      padding:      '8px 14px',
                      borderRadius: '8px',
                      border:       `1.5px solid ${formData.question2_answer === room ? '#c8a04a' : '#e0d8cc'}`,
                      background:   formData.question2_answer === room ? 'rgba(200,160,74,0.08)' : '#fff',
                      transition:   'all 0.2s ease',
                    }}
                  >
                    <input
                      type="radio"
                      name="rooms"
                      value={room}
                      checked={formData.question2_answer === room}
                      onChange={handleChange('question2_answer')}
                      style={{ display: 'none' }}
                    />
                    {room}
                  </label>
                ))}
              </div>
            </div>

            {/* زرار الإرسال */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width:        '100%',
                padding:      '15px',
                marginTop:    '6px',
                background:   loading ? 'rgba(200,160,74,0.5)' : 'linear-gradient(135deg, #b8903a, #c8a04a, #e0b84a)',
                color:        '#fff',
                border:       'none',
                borderRadius: '12px',
                fontSize:     '16px',
                fontWeight:   '700',
                fontFamily:   "'Cairo', sans-serif",
                cursor:       loading ? 'not-allowed' : 'pointer',
                boxShadow:    '0 6px 20px rgba(200,160,74,0.35)',
                transition:   'all 0.25s ease',
                letterSpacing:'0.5px',
              }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.boxShadow = '0 10px 28px rgba(200,160,74,0.5)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(200,160,74,0.35)'; }}
            >
              {loading ? 'جاري الإرسال...' : 'إرسال'}
            </button>
          </form>
        </div>
      </div>

      <style>{`
        @keyframes emmarFadeInUp {
          from { opacity: 0; transform: translateY(24px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }
        @media (max-width: 420px) {
          .emmar-modal-tight { padding: 14px !important; }
        }
      `}</style>
    </div>
  );
};